export const skillsdata = [
  {
    value: "react",
    label: "React",
  },
  {
    value: "vue",
    label: "Vue",
  },
  {
    value: "java",
    label: "Java",
  },
  {
    value: "frontend",
    label: "Frontend",
  },
  {
    value: "backend",
    label: "Backend",
  },
  {
    value: "php",
    label: "Php",
  },
  {
    value: "python",
    label: "Python",
  },
  {
    value: "Go",
    label: "Go",
  },
  {
    value: "angular",
    label: "Angular",
  },
  {
    value: "mobile",
    label: "Mobile",
  },
  {
    value: "javascript",
    label: "Javascript",
  },
  {
    value: "node",
    label: "Node",
  },
];
